import {
    Component,
    ContentChildren,
    ElementRef,
    Input,
    QueryList,
} from '@angular/core';
import {
    WdxButtonSize,
    WdxButtonStyle,
} from '@wdx/shared/components/wdx-button';
import { WdxAlertComponent } from '../wdx-alert.component';

@Component({
    selector: 'wdx-alert-list',
    templateUrl: './wdx-alert-list.component.html',
    standalone: false,
    host: { '[class]': 'hostClass' },
})
export class WdxAlertListComponent {
    private _collapseLimit: number | undefined = 3;
    @Input()
    set collapseLimit(value: number | undefined) {
        this._collapseLimit = value;
        this.collapseAlerts();
    }
    get collapseLimit(): number | undefined {
        return this._collapseLimit;
    }

    private _alertChildren: Array<ElementRef> = [];
    protected get alertChildren(): Array<ElementRef> {
        return this._alertChildren;
    }

    @ContentChildren(WdxAlertComponent, { read: ElementRef })
    protected set alertChildren(alertChildren: QueryList<ElementRef>) {
        this._alertChildren = alertChildren.toArray();
        this.collapseAlerts();
    }

    protected collapsed = true;
    protected get hostClass(): string {
        return this.collapsed
            ? 'd-flex flex-column'
            : 'd-flex flex-column max-h-100 overflow-none';
    }

    protected WdxButtonStyle = WdxButtonStyle;
    protected WdxButtonSize = WdxButtonSize;

    private readonly DISPLAY_NONE_CLASS = 'd-none';

    protected collapseAlerts() {
        if (!this.alertChildren?.length) {
            return;
        }

        this.alertChildren.forEach((alert) => {
            alert.nativeElement.classList.remove(this.DISPLAY_NONE_CLASS);
        });

        if (this.collapseLimit === undefined || !this.collapsed) {
            return;
        }

        if (this.alertChildren.length > this.collapseLimit) {
            this.alertChildren.slice(this.collapseLimit).forEach((alert) => {
                alert.nativeElement.classList.add(this.DISPLAY_NONE_CLASS);
            });
        }
    }

    protected toggleCollapse() {
        this.collapsed = !this.collapsed;
        this.collapseAlerts();
    }
}
